import { Buffer } from 'buffer';
import browserProcess from 'process';
import 'regenerator-runtime/runtime.js';
globalThis.Buffer ??= Buffer;
if (process.env.WEB) {
  browserProcess.env = { ...browserProcess.env, ...globalThis.process?.env };
  globalThis.process = browserProcess;
}
globalThis.global ??= globalThis;
document.documentElement.lang = localStorage.getItem('theme') || 'en_light_old';
import('./index.js');
